import { Navigate, Route, Routes } from 'react-router-dom';
import { SessionProvider } from './features/auth/session-provider';
import { RequireAuth } from './features/auth/require-auth';
import { ScrollToTop } from './components/scroll-to-top';
import { PWAInstallBanner } from './components/pwa-install-banner';
import { LandingPage } from './pages/landing';
import { LoginPage } from './pages/login';
import { SignupPage } from './pages/signup';
import { HomePage } from './pages/home';
import { NewProfilePage } from './pages/new-profile';
import { ProfilePage } from './pages/profile';
import { AddPage } from './pages/add';
import { ManualEntryPage } from './pages/manual-entry';
import { ReviewPage } from './pages/review';
import { EditEventPage } from './pages/edit-event';
import { EditProfilePage } from './pages/edit-profile';
import { ProfileChatPage } from './pages/profile-chat';
import { SharePage } from './pages/share';
import { SettingsPage } from './pages/settings';
import { VitalsPage } from './pages/vitals';
import { NotFoundPage } from './pages/not-found';

export default function App() {
  return (
    <SessionProvider>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        <Route
          path="/home"
          element={
            <RequireAuth>
              <HomePage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/new"
          element={
            <RequireAuth>
              <NewProfilePage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id"
          element={
            <RequireAuth>
              <ProfilePage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id/vitals"
          element={
            <RequireAuth>
              <VitalsPage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id/edit"
          element={
            <RequireAuth>
              <EditProfilePage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id/add"
          element={
            <RequireAuth>
              <AddPage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id/chat"
          element={
            <RequireAuth>
              <ProfileChatPage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id/manual"
          element={
            <RequireAuth>
              <ManualEntryPage />
            </RequireAuth>
          }
        />
        <Route
          path="/profile/:id/event/:eventId/edit"
          element={
            <RequireAuth>
              <EditEventPage />
            </RequireAuth>
          }
        />
        <Route
          path="/add"
          element={
            <RequireAuth>
              <AddPage />
            </RequireAuth>
          }
        />
        <Route
          path="/review"
          element={
            <RequireAuth>
              <ReviewPage />
            </RequireAuth>
          }
        />
        <Route
          path="/settings"
          element={
            <RequireAuth>
              <SettingsPage />
            </RequireAuth>
          }
        />
        <Route path="/share/:token/:name" element={<SharePage />} />
        <Route path="/share/:token" element={<SharePage />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
      <PWAInstallBanner />
    </SessionProvider>
  );
}
